import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor() {}

  async pngToJpg(png: string) {
    const image = await this.loadingImage(png);
    const width = image.width as number;
    const height = image.height as number;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.setAttribute("background-color", "white");
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#FFF";
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(image, 0, 0);
    const jpg = canvas.toDataURL("image/jpeg", 0.8);
    return jpg;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  private loadingImage(png): Promise<CanvasImageSource>{
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = png;
    });
  }
}


